export const GET_ACTIVE_ZIP = "GET_ACTIVE_ZIP"
export const UPDATE_ACTIVE_ZIP = "UPDATE_ACTIVE_ZIP"
export const KEY = "AIzaSyDlf1MIIl0lY6Sqvn8rI-hoXB2WRQs5fMc"
export const DEFAULT_ZIP = "60605"
